export const imgSrc = (url) =>
  url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
